import {useEffect, useRef} from "react";
import {FormProvider, useForm, useWatch} from "react-hook-form";

import {budgetFilterDefaults} from "../../../real_estate/constants/budget_filter_defaults";
import {BudgetFieldsNames} from "../../../real_estate/types/BudgetFieldsNames";
import {IPropertyConfiguratorFiltersForm} from "../../types/IPropertyConfiguratorFiltersForm";
import {PropertyConfiguratorSearchFormValuesType} from "../../types/PropertyConfiguratorSearchFormValuesType";
import {PropertyConfiguratorBudgetFilter} from "./PropertyConfiguratorBudgetFilter";

interface IProps {
    defaultValues: IPropertyConfiguratorFiltersForm;
    budget: {
        totalMax: number;
    };
    onChange?: (value: Partial<PropertyConfiguratorSearchFormValuesType>) => void;
}

export function PropertyConfiguratorFilters(props: IProps) {
    const {defaultValues, budget, onChange} = props;
    const prevTotalMaxRef = useRef<number>(budget.totalMax);

    const formMethods = useForm<IPropertyConfiguratorFiltersForm>({
        defaultValues
    });

    // Auto-set max value when totalMax changes and previous value was at max
    useEffect(() => {
        const currentValues = formMethods.getValues();
        const wasAtMax =
            currentValues[BudgetFieldsNames.TOTAL] >= prevTotalMaxRef.current || currentValues[BudgetFieldsNames.TOTAL] >= budgetFilterDefaults.totalMax;

        if (wasAtMax && budget.totalMax !== prevTotalMaxRef.current) {
            formMethods.setValue(BudgetFieldsNames.TOTAL, budget.totalMax, {shouldValidate: true});
        }

        prevTotalMaxRef.current = budget.totalMax;
    }, [budget.totalMax]);

    return (
        <FormProvider {...formMethods}>
            <LegacyFormHandler onChange={onChange} />
            <PropertyConfiguratorBudgetFilter totalMax={budget.totalMax} />
        </FormProvider>
    );
}

function LegacyFormHandler(props: {onChange?: IProps["onChange"]}) {
    const {onChange} = props;

    const price = useWatch<IPropertyConfiguratorFiltersForm>({name: BudgetFieldsNames.TOTAL});
    const instalment = useWatch<IPropertyConfiguratorFiltersForm>({name: BudgetFieldsNames.CREDIT});
    const radioType = useWatch<IPropertyConfiguratorFiltersForm>({name: BudgetFieldsNames.RADIO});

    useEffect(() => {
        if (radioType === "total" && onChange) {
            onChange({price: {lower: "", upper: price.toString()}, instalment: 0});
        }

        if (radioType === "monthly" && onChange) {
            onChange({instalment: instalment, price: {lower: "", upper: ""}});
        }
    }, [price, instalment, radioType]);

    return null;
}
import {useEffect, useRef} from "react";
import {FormProvider, useForm, useWatch} from "react-hook-form";

import {budgetFilterDefaults} from "../../../real_estate/constants/budget_filter_defaults";
import {BudgetFieldsNames} from "../../../real_estate/types/BudgetFieldsNames";
import {IPropertyConfiguratorFiltersForm} from "../../types/IPropertyConfiguratorFiltersForm";
import {PropertyConfiguratorSearchFormValuesType} from "../../types/PropertyConfiguratorSearchFormValuesType";
import {PropertyConfiguratorBudgetFilter} from "./PropertyConfiguratorBudgetFilter";

interface IProps {
    defaultValues: IPropertyConfiguratorFiltersForm;
    budget: {
        totalMax: number;
    };
    onChange?: (value: Partial<PropertyConfiguratorSearchFormValuesType>) => void;
}

export function PropertyConfiguratorFilters(props: IProps) {
    const {defaultValues, budget, onChange} = props;
    const prevTotalMaxRef = useRef<number>(budget.totalMax);

    const formMethods = useForm<IPropertyConfiguratorFiltersForm>({
        defaultValues
    });

    // Auto-set max value when totalMax changes and previous value was at max
    useEffect(() => {
        const currentValues = formMethods.getValues();
        const wasAtMax =
            currentValues[BudgetFieldsNames.TOTAL] >= prevTotalMaxRef.current || currentValues[BudgetFieldsNames.TOTAL] >= budgetFilterDefaults.totalMax;

        if (wasAtMax && budget.totalMax !== prevTotalMaxRef.current) {
            formMethods.setValue(BudgetFieldsNames.TOTAL, budget.totalMax, {shouldValidate: true});
        }

        prevTotalMaxRef.current = budget.totalMax;
    }, [budget.totalMax]);

    return (
        <FormProvider {...formMethods}>
            <LegacyFormHandler onChange={onChange} />
            <PropertyConfiguratorBudgetFilter totalMax={budget.totalMax} />
        </FormProvider>
    );
}

function LegacyFormHandler(props: {onChange?: IProps["onChange"]}) {
    const {onChange} = props;

    const price = useWatch<IPropertyConfiguratorFiltersForm>({name: BudgetFieldsNames.TOTAL});
    const instalment = useWatch<IPropertyConfiguratorFiltersForm>({name: BudgetFieldsNames.CREDIT});
    const radioType = useWatch<IPropertyConfiguratorFiltersForm>({name: BudgetFieldsNames.RADIO});

    useEffect(() => {
        if (radioType === "total" && onChange) {
            onChange({price: {lower: "", upper: price.toString()}, instalment: 0});
        }

        if (radioType === "monthly" && onChange) {
            onChange({instalment: instalment, price: {lower: "", upper: ""}});
        }
    }, [price, instalment, radioType]);

    return null;
}
